import { render, staticRenderFns } from "./Mgm2026.vue?vue&type=template&id=1c71d31e&scoped=true&"
import script from "./Mgm2026.vue?vue&type=script&lang=js&"
export * from "./Mgm2026.vue?vue&type=script&lang=js&"
import style0 from "./Mgm2026.vue?vue&type=style&index=0&id=1c71d31e&lang=scss&scoped=true&"
import style1 from "./Mgm2026.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71d31e",
  null
  
)

export default component.exports